export default "/images/b93db41bf6c6ec8f011c7233bc713a0e.avif";